import { r as redirect } from "../../chunks/index3.js";
function load({ url }) {
  if (url.pathname !== "/") {
    redirect(308, "/");
  }
}
export {
  load
};
